import React, { useState } from "react";
import { Link } from "react-router-dom";

import { lessonLink } from "lib/paths";
import LessonPicker from "features/player/LessonPicker";
import RateClass from "features/player/RateClass";
import { Chevron, StatusDot, VideoIcon } from "features/player/icons";

// Left column: course card (title, progress, rating), the lesson picker and the
// chapter accordion with a lesson timeline.
export default function PlayerOutline({ courseId, course, lessons, current, done, percent, goTo }) {
  // Every chapter starts open so any lesson is one click away.
  const [closed, setClosed] = useState({});

  const chapters = course?.chapters ?? [];

  return (
    <aside className="yc-player-side">
      <div className="yc-player-head">
        <h1 className="yc-player-course">{course?.name}</h1>
        <div className="yc-player-bar" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
          <span style={{ width: `${percent}%` }}></span>
        </div>
        <p className="yc-player-percent">
          <b>{percent}%</b> complete
        </p>
        <RateClass courseId={courseId} />
      </div>

      <LessonPicker lessons={lessons} current={current} done={done} onPick={goTo} />

      <nav className="yc-player-outline" aria-label="Class outline">
        {chapters.map((chapter) => {
          const all = chapter.lessons ?? [];
          const count = all.filter((l) => done.has(l.id)).length;
          const open = !closed[chapter.id];
          return (
            <div key={chapter.id} className={`yc-player-chapter${open ? " is-open" : ""}`}>
              <button type="button" className="yc-player-chapter-head" aria-expanded={open} onClick={() => setClosed((c) => ({ ...c, [chapter.id]: open }))}>
                <StatusDot done={all.length > 0 && count === all.length} />
                <span className="yc-player-chapter-name">{chapter.name}</span>
                <span className="yc-player-chapter-count">
                  {count} / {all.length}
                </span>
                <Chevron up={open} />
              </button>
              {open && (
                <ol className="yc-player-lessons">
                  {all.map((lesson) => {
                    const active = lesson.id === current.id;
                    const complete = done.has(lesson.id);
                    return (
                      <li key={lesson.id}>
                        <Link
                          to={lessonLink(courseId, { ...lesson, chapter })}
                          className={`yc-player-lesson${active ? " is-active" : ""}`}
                          aria-current={active ? "true" : undefined}
                        >
                          <StatusDot done={complete} size={18} />
                          <span>
                            <span className="yc-player-lesson-name">{lesson.name}</span>
                            <span className="yc-player-lesson-meta">
                              <VideoIcon /> Video{complete ? " · Completed" : ""}
                            </span>
                          </span>
                        </Link>
                      </li>
                    );
                  })}
                </ol>
              )}
            </div>
          );
        })}
      </nav>
    </aside>
  );
}
